import { FC, FunctionComponent, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import MeetSidebar from "../../components/MeetSidebar/MeetSidebar";
import './MeetLayout.scss'
import { CHIME, JITSI } from "../../utils/constants";
import { useAppSelector } from "../../redux/app/hooks";
import { captureEvent } from "../../utils/PostHogHelper";
import { useChimeMeeting } from "../../Chime/ChimeMeetingContext";

interface ProType {
  component: FunctionComponent;
}

const MeetLayout: FC<ProType> = ({ component: Component }) => {

  const { meetService, loginpage, role, meetServiceOrganization } = useAppSelector((state) => state.auth);
  const { isMeetjoined } = useAppSelector((state) => state.JitsiMeetSlice);
  const { isStartingMeeting } = useAppSelector((state) => state?.dashboard);

  console.log("[log] Workshop", meetService);

  useEffect(() => {
    captureEvent("MeetLayout", {
      role: role, 
      loginType: loginpage, // your redux login type
    });
  }, []);

  const meetingService =  meetService;
  console.log("[log] Workshop", meetingService);
  const {isShowParticipants}=useChimeMeeting()
  return (
    <>
      {/* {
        !isOnline ? 
        (
          <div className="disconnectLoader">

            <div className="disconnectLoaderContainer">
              <CircularProgress 
                variant="indeterminate"
                color="warning" 
                size={35}
              />
              <p className="disconnectLoaderText">
                Network disconnected. If you want to use classroom reconnect again...
              </p>
            </div>
          </div>
        ) :
        (
          <> */}
            <div className="meetMainContainer" style={{height: isShowParticipants ? "86%" : "100%"}}>
              <div className={`meetSidebarContianer ${ ((!isMeetjoined && meetingService === JITSI) || (meetingService === CHIME && isStartingMeeting)) ? "hideMeetSidebarContianer" : "" }`}>
                  <MeetSidebar />   
              </div>
              <div className={meetingService === JITSI ? 'jitsiMeetVideoContainer' : 'meetVideoContainer' }>
                <Component />
              </div>
            </div>
            <ToastContainer
              position="top-center"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          {/* </>
        )
      } */}
      
    </>
  );
};
export default MeetLayout;
